import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 8.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const CobrandDropdown = ({ 
    paramCobrand, 
    setParamCobrand, 
    cobrandOptions, 
    isLoading, 
    isDisabled = false,
}) => {
    return (
        <FormControl fullWidth variant="outlined" disabled={isLoading || isDisabled}>
            <InputLabel id="cobrand-label">Cobrand</InputLabel>
            <Select
                labelId="cobrand-label"
                id="cobrand-multi-select"
                multiple
                value={paramCobrand}
                onChange={(event, childNode) => {
                    // If the clicked item is the "Select All" MenuItem (which has no 'value' prop),
                    // its own onClick handler has already updated the state.
                    // So, we return early to prevent the Select's onChange from overriding it.
                    if (
                        childNode &&
                        childNode.props &&
                        childNode.props.value === undefined
                    ) {
                        return;
                    }
                    // For regular MenuItems, update paramCobrand with the new value from the event.
                    setParamCobrand(event.target.value);
                }}
                input={<OutlinedInput label="Cobrand" />}
                renderValue={(selected) => {
                    const maxDisplayCount = 2; // Limit the number of displayed cobrands
                    const selectedOptions = cobrandOptions.filter((option) =>
                        selected.includes(option.id)
                    );
                    const displayedOptions = selectedOptions
                        .slice(0, maxDisplayCount)
                        .map((option) => option.name);
                    const additionalCount =
                        selectedOptions.length - maxDisplayCount;

                    return (
                        <>
                            {displayedOptions.join(', ')}
                            {additionalCount > 0 && (
                                <span className="italic text-gray-500">
                                    , {additionalCount} more
                                </span>
                            )}
                        </>
                    );
                }}
                MenuProps={MenuProps}
            >
                {cobrandOptions.length >= 2 && (
                    <MenuItem
                        onClick={() => {
                            if (
                                paramCobrand.length === cobrandOptions.length
                            ) {
                                setParamCobrand([]);
                            } else {
                                setParamCobrand(
                                    cobrandOptions.map((option) => option.id)
                                );
                            }
                        }}
                    >
                        <ListItemText
                            slotProps={{
                                primary: { style: { textAlign: 'center' } },
                            }}
                            primary={
                                paramCobrand.length === cobrandOptions.length
                                    ? '— Deselect All —'
                                    : '— Select All —'
                            }
                        />
                    </MenuItem>
                )}
                {cobrandOptions.map((x) => (
                    <MenuItem key={x.id} value={x.id}>
                        <Checkbox checked={paramCobrand.includes(x.id)} />
                        <ListItemText primary={x.name} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CobrandDropdown;
